/**
 * Countdown helpers for the Black Friday landing page headline.
 *
 * Black Friday 2026 falls on 27 November. The month is 0-indexed here, so
 * `10` = November.
 */
export const BLACK_FRIDAY = { year: 2026, month: 10, day: 27 } as const;

const MS_PER_DAY = 24 * 60 * 60 * 1000;

/** Whole days from the start of `now`'s day until Black Friday. */
export function getDaysUntilBlackFriday(now: Date): number {
  const target = new Date(
    BLACK_FRIDAY.year,
    BLACK_FRIDAY.month,
    BLACK_FRIDAY.day
  );
  const startOfToday = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate()
  );
  return Math.round((target.getTime() - startOfToday.getTime()) / MS_PER_DAY);
}

/**
 * Human-readable time remaining until Black Friday, e.g. "2 weeks and 1 day".
 * Weeks and days are pluralised, and either term is dropped when it is zero.
 */
export function getCountdownLabel(now: Date): string {
  const totalDays = getDaysUntilBlackFriday(now);
  if (totalDays <= 0) return "less than a day";

  const weeks = Math.floor(totalDays / 7);
  const days = totalDays % 7;
  const parts: string[] = [];
  if (weeks > 0) parts.push(`${weeks} ${weeks === 1 ? "week" : "weeks"}`);
  if (days > 0) parts.push(`${days} ${days === 1 ? "day" : "days"}`);

  return parts.join(" and ");
}
